module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid26_1060x855.a7e2cb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid26_1060x855.jpg
// module id = DBPz
// module chunks = 0